import React from "react";
import {
  FormField,
  FormRadioCheckboxButton,
  FormRadioCheckboxGroup,
  Text,
  Button,
  Box
} from "@nef/core";
import styled from "styled-components";

const StyledPricingAgentInformation = styled(Box)`
  width: 500px;
  margin: auto;
  margin-top: 50px;

  .button {
    margin-left: 75px;
  }

  .action-buttons{
    margin-bottom: 20px;
  }
`;

export default StyledPricingAgentInformation;
